import { render } from "./list-history-success-booking.vue?vue&type=template&id=4a55879a&ts=true"
import script from "./list-history-success-booking.vue?vue&type=script&lang=ts"
export * from "./list-history-success-booking.vue?vue&type=script&lang=ts"

import "./list-history-success-booking.vue?vue&type=style&index=0&id=4a55879a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__